import { createSelector } from '@reduxjs/toolkit'

const getStateOrderListDownload = state => state.orderDownload

export const getOrderListDownload = createSelector(
  [getStateOrderListDownload],
  product => product
)
